import { AuthorizationParams, Auth0Provider as Provider } from '@auth0/auth0-react'

import openIdConfig from './openIdConfig.json'

const env = process.env['REACT_APP_ENV'] ?? 'dev'

const { domain, clientId, issuer } = openIdConfig[env as keyof typeof openIdConfig]
const redirectUri = window.location.href

const onRedirectCallback = (appState: any) => {
}
const authorizationParams: AuthorizationParams =
{
  redirect_uri: redirectUri,
  audience: 'https://terashite.miraiz-connect.co.jp/'
}
const Auth0Provider = ({ children }: { children: any }) => {
  return (
    <Provider
      domain={domain}
      clientId={clientId}
      issuer={issuer}
      authorizationParams={authorizationParams}
      onRedirectCallback={onRedirectCallback}>
      {children}
    </Provider>
  )
}

export default Auth0Provider
